import appConfig from '@/config';

export const OPEN_DATA_PARTNER_AB_TEST_THRESHOLD = 51615;

export function isOrgInAbTestGroup(orgId: number, threshold: number): boolean {
  return orgId <= threshold || orgId % 3 === 0;
}

export function isOrgInSmartOnboardingTestGroup(orgId: number): boolean {
  if (appConfig.env !== 'prod') return true;
  return orgId % 3 === 0;
}
